import { getMarket } from 'helpers/market';
import { getKey, getPlural, getLanguage } from '../localisationFunctions';
import LocalContainer from '../LocalContainer';
import { route } from '../route';
import SE from '../data/hubins/registration_se';
import c_SE from '../data/common/registration_se';

const MARKET = getMarket();
const LANGUAGE = getLanguage(MARKET);

// The data
import { fallback } from '../localisationFunctions';
import EN from '../data/hubins/registration_en';
import c_EN from '../data/common/registration_en';

// let SE = fallback;
// let NO = fallback;
// let FI = fallback;

// let c_SE = fallback;
// let c_NO = fallback;
// let c_FI = fallback;

// if (import.meta.env.VITE_MARKET === 'no') {
//   NO = require('../data/hubins/registration_no').default;
//   c_NO = require('../data/common/registration_no').default;
// }

// if (import.meta.env.VITE_MARKET === 'fi') {
//   FI = require('../data/hubins/registration_fi').default;
//   c_FI = require('../data/common/registration_fi').default;
//   SE = require('../data/hubins/registration_se').default;
//   c_SE = require('../data/common/registration_se').default;
// }

const languageObjects = {
  'SE': SE,
  // 'NO': NO,
  // 'FI': FI,
  'EN': EN,
};

const commonObjects = {
  'SE': c_SE,
  // 'NO': c_NO,
  // 'FI': c_FI,
  'EN': c_EN,
};

export const __ = (string, vars) => {
  return LocalContainer({ method: getKey, string: string, vars: vars, market: MARKET, language: LANGUAGE, languageObjects, commonObjects, fallbackObject: c_EN });
};

export const __plural = (string, number, vars) => {
  return LocalContainer({ method: getPlural, string: string, vars: vars, number: number, market: MARKET, language: LANGUAGE, languageObjects, commonObjects, fallbackObject: c_EN });
};

export const __route = (key, props) => route(key, props, LANGUAGE);

export default __;
